<div class="title-page image cz-color-2696481 cz-color-11586651">
  <div class="container">
    <div class="text-center {{ pageHeader.style }}">
      <h1 *ngIf="pageHeader.title">{{ pageHeader.title }}</h1>
      <form
        class="form-search form-icon"
        #searchform="ngForm"
        (ngSubmit)="redirectTag(searchform.value.search)"
      >
        <div class="col-lg-5 mx-auto">
          <input
            class="form-control rounded transparent mp_input"
            id="form-search"
            name="search"
            type="text"
            placeholder="Busque por palavras-chave, tutoriais ou dúvidas"
            aria-autocomplete="list"
            aria-owns="mp_s_list"
            aria-controls="mp_s_list"
            [attr.aria-expanded]="
              paginatedArticles !== undefined &&
              paginatedArticles.artigos.length > 0
            "
            autocomplete="off"
            role="combobox"
            aria-required="false"
            [(ngModel)]="search"
            [attr.aria-activedescendant]="
              highlightedIndex >= 0 ? 'mp_item_' + highlightedIndex : null
            "
            (ngModelChange)="valuechange($event)"
            (focus)="onFocusSearch()"
            (keydown)="onKeyDown($event)"
            #searchWrapper
          />
          <ol
            class="mp_list"
            aria-atomic="true"
            aria-busy="false"
            aria-live="polite"
            role="listbox"
            style="display: block"
            id="mp_s_list"
            *ngIf="isDropdownOpen"
          >
            <li *ngIf="notFound && characters > 2">
              <em>
                Nenhum resultado para
                <strong>{{ searchform.value.search }}</strong>.
              </em>
            </li>
            <li
              *ngFor="let article of paginatedArticles.artigos.slice(0, 10); let i = index"
              class="mp_item mp_selectable"
              [class.highlighted]="i === highlightedIndex"
              role="option"
              [id]="'mp_item_' + i"
              tabindex="-1"
              (click)="redirectArticle(article.resumo, article.categoria)"
            >
              <strong>{{ article.titulo }}</strong>
              <br/>
              <div class="mp_description">{{ article.META.descricao }}</div>
            </li>
          </ol>
          <button class="" type="submit">
            <i class="fa fa-search fa-lg"></i>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
